import { Gallery, Pen } from "@papier/ui/components/icons";
import { cn } from "@papier/ui/lib/utils";

export function EditorLoading({ className }: { className?: string }) {
  return (
    <div
      role="status"
      aria-label="Preparing your editor"
      className={cn(
        "flex size-full min-h-64 flex-col items-center justify-center gap-7 bg-background px-6 py-10 text-center",
        className,
      )}
    >
      <div aria-hidden="true" className="relative flex h-44 w-52 items-center justify-center">
        <div className="absolute size-56 rounded-full bg-radial from-primary/10 to-transparent to-70%" />
        <div className="absolute h-36 w-28 translate-x-3 rotate-12 rounded-xl border border-primary/10 bg-primary/5" />
        <div className="absolute h-36 w-28 -translate-x-2 -rotate-6 rounded-xl border bg-muted/70" />
        <div className="relative flex h-36 w-28 flex-col gap-2.5 rounded-xl border bg-card p-3.5 shadow-lg shadow-primary/5 motion-safe:animate-editor-paper">
          <div className="flex h-14 items-center justify-center rounded-md bg-primary/10 text-primary/60">
            <Gallery className="size-6" />
          </div>
          <div className="h-1.5 w-3/4 rounded-full bg-foreground/15" />
          <div className="h-1 w-full rounded-full bg-muted-foreground/15" />
          <div className="h-1 w-2/3 rounded-full bg-muted-foreground/15" />
          <div className="mt-auto h-3 w-9 rounded-sm bg-primary/70" />
        </div>
        <div className="absolute right-4 bottom-2 flex size-10 items-center justify-center rounded-xl border border-background bg-primary text-primary-foreground shadow-lg shadow-primary/15">
          <Pen className="size-5" />
        </div>
      </div>
      <div className="space-y-2">
        <p className="text-base font-semibold tracking-tight text-foreground">
          Preparing your editor
        </p>
        <p className="text-sm text-muted-foreground">Making room for your next great message.</p>
      </div>
      <div aria-hidden="true" className="flex gap-1.5 text-primary">
        <span className="size-1.5 rounded-full bg-current motion-safe:animate-pulse" />
        <span className="size-1.5 rounded-full bg-current [animation-delay:200ms] motion-safe:animate-pulse" />
        <span className="size-1.5 rounded-full bg-current [animation-delay:400ms] motion-safe:animate-pulse" />
      </div>
    </div>
  );
}
